// extracted by mini-css-extract-plugin
var _1 = "extras-module_agreeWrap_j9CZZ";
var _2 = "extras-module_closeIcon_lLeWd";
var _3 = "extras-module_educationMainWrapper_KLnTB";
var _4 = "extras-module_extrasButtonElement_I1yFY";
var _5 = "extras-module_extrasButtonWrapper_ctFXQ";
var _6 = "extras-module_extrasColor_CysVb";
var _7 = "extras-module_extrasDisclaimer_bIPsg";
var _8 = "extras-module_extrasHeaderWrapper_YdBIn";
var _9 = "extras-module_extrasInputWrapper_Buoxq";
var _a = "extras-module_extrasMainWrapper_rNRzl";
var _b = "extras-module_extrasSmallHeader_VWoGh";
var _c = "extras-module_extrasSmallHeaderWrapper_U2v6N";
var _d = "extras-module_extrasWrapper_ljasi";
var _e = "extras-module_learningPathHeaderWrapper_v6MHt";
var _f = "extras-module_markers_ZuDI7";
var _10 = "extras-module_questionMark_SVPDV";
var _11 = "extras-module_tooltip_eZOoy";
var _12 = "extras-module_tooltipClose_wzsTX";
export { _1 as "agreeWrap", _2 as "closeIcon", _3 as "educationMainWrapper", _4 as "extrasButtonElement", _5 as "extrasButtonWrapper", _6 as "extrasColor", _7 as "extrasDisclaimer", _8 as "extrasHeaderWrapper", _9 as "extrasInputWrapper", _a as "extrasMainWrapper", _b as "extrasSmallHeader", _c as "extrasSmallHeaderWrapper", _d as "extrasWrapper", _e as "learningPathHeaderWrapper", _f as "markers", _10 as "questionMark", _11 as "tooltip", _12 as "tooltipClose" }
